import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'list-cms-collections' as const;

// Empty object since we don't need arguments - site comes from context
const argumentZod = z.object({});

export const listCMSCollectionsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List CMS collections',
  family: 'cms',
  llmTool: {
    name: toolName,
    description:
      'Lists all CMS collections for the current site, including their names, and slugs.',
    inputSchema: argumentZod,
  },
  type: 'server',
  // Site-scoped: lists all collections, no per-collection FGAC needed
  permission: [{resource: 'SiteCollection', action: 'read'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});
